import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
//Component
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import BootstrapTable from 'react-bootstrap-table-next';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import Grid from "@material-ui/core/Grid";
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
//Function
import * as api from "./api";
import { getColumns } from "./columns/job-schedule-quota";
import { GetUser } from "../../utils/sessions";
import * as alertDialog from "../../utils/alert";
import { useSelectItem } from "../../stories/react-table/useSelectItem";
import { Button } from "@material-ui/core";
import { isEmptyArray } from "../../utils/common-function";
import { makeStyles } from '@material-ui/core/styles';
import ModalAddEditQuota from "./add-edit-quota"

const useStyles = makeStyles((theme) => ({
  rootSearch: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    width: 600,
  },
  rootButton: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    width: 150,
  },
  searchText: {
    textAlign: '-webkit-right'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
  },
  iconButtonActiveInactive: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
  divider: {
    height: 28,
    margin: 4,
  },
  buttonGrid: {
    // textAlign: "right",
    // align: "right",
  },
  textYellow: {
    color: '#FFCC00'
  },
  textRed: {
    color: '#FF0000'
  },
  textGrey: {
    color: '#CCCCCC'
  }
}));
function ScheduleQuota() {
  //State
  const classes = useStyles();
  //State
  const method = useForm();
  const { register, getValues } = method;
  const [DataList, setDataList] = useState([]);
  const [openModalAddEdit, setOpenModalAddEdit] = useState(false);
  const [UserID, setUSERID] = useState();
  const [statusSearch, setStatusSearch] = useState("");
  const { handleOnSelect, handleOnSelectAll, SelectedItems } = useSelectItem(
    "USER_ID"
  );
  const [state, setState] = useState({
    checkActive: false,
    checkInActive: false
  });


  //Effect
  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    let param = { "TEXT_SEARCH": "", "ACTIVE": false,"INACTIVE": false};
    let res = await api.GetListJobScheduleQuota(param);
    setDataList(res);
  }
  const SearchText = async () => {
    setDataList([]);

    let param = { "TEXT_SEARCH": getValues().TEXT_SEARCH, "ACTIVE": state.checkInActive,"INACTIVE": state.checkInActive};
    //console.log(param);
    let res = await api.GetListJobScheduleQuota(param);
    setDataList(res);
    handleOnSelectAll(false);

  }
  const handleChangeStatusActive = async (event) => {

    setState({ ...state, [event.target.name]: event.target.checked });

    setDataList([]);
    let param = { "TEXT_SEARCH": getValues().TEXT_SEARCH, "ACTIVE": event.target.checked ,"INACTIVE" : state.checkInActive };
    //console.log(param);
    let res = await api.GetListJobScheduleQuota(param);
    setDataList(res);
    handleOnSelectAll(false);

  }
  const handleChangeStatusInactive = async (event) => {

    setState({ ...state, [event.target.name]: event.target.checked });

    setDataList([]);
    let param = { "TEXT_SEARCH": getValues().TEXT_SEARCH, "ACTIVE": state.checkActive,"INACTIVE" : event.target.checked };
    //console.log(param);
    let res = await api.GetListJobScheduleQuota(param);
    setDataList(res);
    handleOnSelectAll(false);

  }

  const onAddEdit = async (User_ID) => {
    console.log(User_ID);
    setUSERID(User_ID);
    setOpenModalAddEdit(true);
  }
  const onCloseAddEdit = () => {
    setOpenModalAddEdit(false);
  };

 
  const onDelete = async () => {
    if (isEmptyArray(SelectedItems)) {
      alertDialog.ErrorDialog("Please Select Item.");
      return;
    }
    //console.log(SelectedItems);
    let txt = "Do you want to Delete ?";
    let resConfirm = await alertDialog.ConfirmCommon(txt, "Yes", "No");
    if (!resConfirm) return;

    let param = { UserName: SelectedItems ,STATUS : "0"};
    let res = await api.DeleteJobScheduleQuota(param);
    if (res?.ResultCode === 10) {
      alertDialog.Success();
      setDataList([]);
      fetch();
      handleOnSelectAll(false);
      handleOnSelect([]);
    }
    else {
      alertDialog.ErrorDialog("Error : " + res.Message);
    }

  }

  const handleEnter = (e) => {
    if (e.keyCode === 13) {
      SearchText();
      e.preventDefault();
    }
  }

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Schedule Quota Additional">
          <FormProvider {...method}>
            <Grid item xs={12} container spacing={1}>
              <Grid item xs={6} container spacing={1}>
                <Grid item xs={4} className={classes.buttonGrid}>

                  <Button variant="contained" className={classes.iconButtonActiveInactive} onClick={(e) => onAddEdit(undefined)}>
                    Add
                  </Button>
                  <Button variant="contained" className={classes.iconButtonActiveInactive} onClick={onDelete}>
                    Delete
                  </Button>
                </Grid>

              </Grid>
              <Grid item xs={6} className={classes.searchText}>


                <Paper component="form" className={classes.rootSearch}>
                  <InputLabel >Status : </InputLabel>
                  <FormControl variant="outlined" className={classes.textInput}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.checkActive}
                          onChange={handleChangeStatusActive}
                          name="checkActive"
                          color="primary"
                        />
                      }
                      label="Active"
                    />
                  </FormControl>
                  <FormControl variant="outlined" className={classes.textInput}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.checkInActive}
                          onChange={handleChangeStatusInactive}
                          name="checkInActive"
                          color="primary"
                        />
                      }
                      label="Inactive"
                    />
                  </FormControl>
                  <Divider className={classes.divider} orientation="vertical" />
                  <InputBase
                    className={classes.input}
                    placeholder="Search"
                    inputProps={{ 'aria-label': 'search' }}
                    name="TEXT_SEARCH"
                    inputRef={register}
                    onKeyDown={(e) => handleEnter(e)}
                  />
                  {/* <IconButton type="submit" className={classes.iconButton} aria-label="search">
              <SearchIcon />
            </IconButton> */}
                  <Divider className={classes.divider} orientation="vertical" />
                  <Button variant="contained" className={classes.iconButton} onClick={SearchText}>
                    Search
                  </Button>

                </Paper>

              </Grid>
            </Grid>
            {DataList?.length > 0 ?
              (<ReactTable id="1"
                showSearch={false}
                keyField="USER_ID"
                data={DataList}
                clickToSelect
                handleOnSelect={handleOnSelect}
                handleOnSelectAll={handleOnSelectAll}
                columns={getColumns(onAddEdit)}
              />) : <BootstrapTable keyField='JOB_GUID' data={[]} columns={getColumns(onAddEdit)} noDataIndication={'No results found'} />}
          </FormProvider>
          
        </BoxTemplate1>

        
        <ModalAddEditQuota
          open={openModalAddEdit}
          onClose={onCloseAddEdit}
          userID={UserID}
        />
        
      </BaseContainer>
    </div>
  );
}
export default ScheduleQuota;
